import * as React from 'react';
import {
  SectionContainer,
  SectionTitle,
  SectionText,
  LogoImageDesktop,
  LogoImageMobile,
} from './Volunteer.style';
import { MarginContainer } from '../../lib/shared';
import { icons } from '../../style/icons';

const Volunteer = ({ sectionData }) => {
  const {
    document: {
      data: {
        get_involved_section_description: sectionDescription,
        get_involved_section_note: sectionNote,
        get_involved_section_title: sectionTitle,
      },
      id: id,
    },
  } = sectionData;

  return (
    <SectionContainer key={id}>
      <LogoImageDesktop
        src={icons.VOLUNTEER_DESKTOP.image}
        alt={icons.VOLUNTEER_DESKTOP.altText}
      />
      <LogoImageMobile
        src={icons.VOLUNTEER_MOBILE.image}
        alt={icons.VOLUNTEER_MOBILE.altText}
      />
      <MarginContainer>
        <SectionTitle>{sectionTitle.text}</SectionTitle>
        <SectionText>{sectionDescription.text}</SectionText>
        <SectionText>{sectionNote.text}</SectionText>
      </MarginContainer>
    </SectionContainer>
  );
};

export default Volunteer;
